import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202507: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202507",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-07-01",
  endDate: "2025-07-31",
  impressions: 9605,
  clicks: 160,
  adsSpendDollars: 325,
  budgetDollars: 600,
  salesDollars: 1919,
  bestEstimateRoas: 5.9,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.54,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-08-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
